angular.module('env.notifications', ['toastr'])

    // To see how to use angular-toastr see https://github.com/Foxandxss/angular-toastr
    .config(function (toastrConfig) {
        angular.extend(toastrConfig, {
            closeButton: true,
            allowHtml: true,
            closeHtml: "<button>&times;</button>",
            containerId: 'toast-container',
            timeOut: 7000,
            extendedTimeOut: 20000,
            tapToDismiss: false,
            messageClass: 'toast-message',
            positionClass: 'toast-top-right',
            titleClass: 'toast-title',
            toastClass: 'toast',
            iconClasses: {
                error: 'toast-error',
                info: 'toast-info',
                success: 'toast-success',
                warning: 'toast-warning'
            }
        });
    })

;